(ns manage.adset-preview-panel.view.core
  (:require ["@mui/material/Stack$default" :as Stack]
            [manage.adset-preview-panel.view.sidebar :refer [sidebar]]
            [manage.adset-preview-panel.view.templates :refer [templates]]
            [re-frame.core :as rf]
            [uix.core :as uix]))

(defn adset-preview-panel
  "Hiccup for rendering the adset preview page as panel"
  [mobile?]
  (uix/use-effect
   (fn []
     (rf/dispatch [:adset-preview.core/init mobile?])
     #(rf/dispatch [:adset-preview.core/destroy]))
   [mobile?])
  [:> Stack {:direction "row" :flex-grow 1 :overflow "hidden"}
   [sidebar mobile?]
   [templates mobile?]])
